import React, {useState, useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {MenuLateralAB} from './MenuLateralAB';

/* A function that receives a parameter called props. */
export const BuutonMenuLateralAA = (props) => {
	/* Destructuring the props object. */
	const {opcion, stilo, goTo, icon, chageMenuLateralAux, MenuLateralAux} = props;

	/* A hook that allows you to navigate between routes. */
	const navigate = useNavigate();
	/**
	 * `const goToTo = () => { navigate(`/`) }`
	 */
	const goToTo = () => {
		if (MenuLateralAB) {
			chageMenuLateralAux();
		}
		navigate(`/${goTo}`);
	};

	/* Returning a div with a className that is equal to the stilo variable, and when you click on it,
    it will execute the goToTo function. */
	return (
		<>
			{(opcion === 'Mi perfil' || opcion === 'Inicio' || opcion === 'Mi empresa') && (
				<div className='centrador'>
					<div className='separador' />
				</div>
			)}

			<div
				className={stilo}
				onClick={goToTo}
			>
				<div className='textMenuLateralAA'>
					{icon != undefined && <div className='centrador'>{icon}</div>}
					<div className='centradorLeft'>{opcion}</div>
				</div>
			</div>
		</>
	);
};
